.cellHeader {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
}

.filters{
    display: flex;
    gap: 10px;
}
